import crypto from "crypto";
import getEncryptionKey from "@/app/actions/get-key";
import { Info } from "@/types/user";

export async function encrypt(user: Info | string): Promise<string> {
  const data = JSON.stringify(user); 
  const ENCRYPTION_KEY = await getEncryptionKey(); 
  const IV = crypto.randomBytes(16); 
  const cipher = crypto.createCipheriv(
    "aes-256-cbc",
    Buffer.from(ENCRYPTION_KEY, "hex"),
    IV
  );
  let encrypted = cipher.update(data, "utf8", "hex");
  encrypted += cipher.final("hex");
  return `${IV.toString("hex")}:${encrypted}`; 
}

export async function decrypt(encryptedData: string): Promise<Info> {
  const ENCRYPTION_KEY = await getEncryptionKey(); 
  const [iv, encrypted] = encryptedData.split(":");
  const decipher = crypto.createDecipheriv(
    "aes-256-cbc",
    Buffer.from(ENCRYPTION_KEY, "hex"),
    Buffer.from(iv, "hex")
  );
  let decrypted = decipher.update(encrypted, "hex", "utf8");
  decrypted += decipher.final("utf8");
  const data = JSON.parse(decrypted); 
  return data;
}
